import { Action } from 'edocatbase/Global';
import constants from '../constants';
import { reducer as formModal } from "../../ModalTest";

const reducer = (state = {}, action: Action) => {
  switch(action.type){
    case constants.ON_FORM_SUBMIT_PROMISE_ERROR: {
      //Matches 'org.alfresco...: 7575 message' sort of strings and removes everything except of the message.
      const regex = /org(\.\w+)+:\s(\d+\s)*/gi;
      let messageWithoutException;
      
      //Creating same codebook item
      if(action.meta?.formInstanceId == "codeBookCreateForm" && action?.payload?.message.includes("Details can be found in the server logs.")) {
        messageWithoutException = window.Alfresco.messages.global["edocat.forms.cb-exists"]
      //Creating site with error
      } else if (action.payload?.detail && action.payload?.title && action.payload?.status) {
        messageWithoutException = `${action.payload?.status} ${action.payload?.title} ${action.payload?.detail}`
      //Creating same folder Name
      } else if (action.payload?.message && action?.meta?.form?.["prop_cm_name"]) {
        const messageException = action.payload.message?.match(regex)?.[0].trim().replaceAll(":", "");
        const message = messageException && window.Alfresco.util.message(messageException, null, action.meta.form["prop_cm_name"])
        messageWithoutException = message ?? action.payload?.message?.replace(regex, '') ?? action.payload.replace(regex, '');
      //Default error
      } else {
        messageWithoutException = action.payload.replace(regex, '');
      }

      return {
        ...state,
        responseModal: {
          isOpen: true,
          items: {
            text: messageWithoutException,
            severity: 'error',
            formInstanceId: action.meta?.formInstanceId,
          },
        },
      };
    }

    case constants.PROMISE_POST_TAG_ERROR: {
      return {
        ...state,
        responseModal: {
          isOpen: true,
          items: {
            text:
                window.Alfresco.messages.global[
                    action.payload?.message?.includes('exists') ? 'edocat.forms.tag-exists' : 'edocat.forms.tag-exists'
                    ],
            severity: 'error',
            formInstanceId: action.meta?.formInstanceId,
          },
        },
      };
    }

    default: {
      return formModal(state, action);
    }
  }
};

export default reducer;
